import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

const ServerError = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          {/* Logo */}
          <img
            className="mx-auto h-24 w-auto mb-8"
            src="/assets/icons/nazai-studio-logo.png"
            alt="Nazaï Studio Admin"
          />
          
          {/* 500 Error */}
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-primary-600">500</h1>
            <h2 className="text-3xl font-bold text-gray-900 mt-4">Erreur serveur</h2>
            <p className="text-lg text-gray-600 mt-4">
              Une erreur inattendue s'est produite sur le serveur d'administration. 
              L'équipe technique a été notifiée.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-4">
            <button
              onClick={handleRefresh}
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-200"
            >
              <ArrowPathIcon className="h-5 w-5 mr-2" />
              Actualiser la page
            </button>
            
            <div className="block">
              <Link
                to="/"
                className="inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-200"
              >
                <HomeIcon className="h-5 w-5 mr-2" />
                Tableau de bord
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div className="mt-8 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500 mb-4">
              Si le problème persiste, contactez l'équipe technique :
            </p>
            <a
              href="mailto:hello@nazaistudio.ma"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium"
            >
              hello@nazaistudio.ma
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServerError;
